import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var registry = {
  tile: 0,
  'caip10-link': 1,
  model: 2,
  MID: 3
};
function codeByName(name) {
  var index = registry[name];
  if (typeof index !== 'undefined') {
    return index;
  } else {
    throw new Error("No stream type registered for name ".concat(name));
  }
}
function nameByCode(index) {
  var pair = Object.entries(registry).find(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      v = _ref2[1];
    return v === index;
  });
  if (pair) {
    return pair[0];
  } else {
    throw new Error("No stream type registered for index ".concat(index));
  }
}
export var StreamType = /*#__PURE__*/_createClass(function StreamType() {
  _classCallCheck(this, StreamType);
});
StreamType.nameByCode = nameByCode;
StreamType.codeByName = codeByName;